import { Component, Input } from "@angular/core";
import { TaskBankAccount } from "@models/task-request";

@Component({
  selector: "app-bank-account-info-card",
  templateUrl: "./bank-account-info-card.component.html",
  styleUrl: "./bank-account-info-card.component.scss",
})
export class BankAccountInfoCardComponent {
  @Input({ required: true }) changes!: TaskBankAccount;
  @Input() title = "ALTERAÇÕES SOLICITADAS";
}
